module.exports = __webpack_public_path__ + "media/images/masks/avatar-group-hover-last-91ed6a1f07d5daf3561b34f90263eda7.svg";